<template>
  <div class="wim-imagevideo-container tva-row">
    <div v-if="content.option === 'video'" class="wim-video-container tva-col-sm-offset-1 tva-col-sm-10">
       <video 
          class="wim-lazy-video"
          :poster="`${baseUrl}images/${content.asset}${$retina ? '@2x' : ''}.jpg`" 
          :controls="$mq === 'mobile' ? true : false"
          :autoplay="$mq === 'mobile' ? false : true"
          playsinline="true"
          loop="true"
          :muted="$mq === 'mobile' ? false : true" 
          style="position: absolute; top:0; width: calc(100% + 1px); left: -1px; max-width: none"
        >
          <source :data-src="`${baseUrl}images/${content.asset}.mp4`" type="video/mp4">
       </video>
     
    </div>

    <div v-if="content.option === 'image' && content.extension !== 'svg'" class="tva-col-sm-offset-1 tva-col-sm-10">
      <div class="wim-image-container">
        <img class="wim-image" v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.name}${$retina ? '@2x' : ''}.jpg`" alt="image">
      </div>
    </div>
    <div v-if="content.option === 'image' && content.extension === 'svg'" class="tva-col-sm-offset-2 tva-col-sm-8">
      <div class="wim-image-container svg">
        <img class="wim-image" v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.name}.svg`" alt="image">
      </div>
    </div>
  </div>
</template>
<script>
import LazyLoad from 'vanilla-lazyload'

export default {
  props: ["content"],
  mounted() {
    this.$nextTick(() => {
      var myLazyLoad = new LazyLoad({
          elements_selector: ".wim-lazy-video"
      });
    })
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-imagevideo-container {
  width: 100%;

  .wim-image-container {
    height: 0;
    padding-bottom: 66.66%;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      position: absolute;
      top:0;
      left:0;
    }
    &.svg{
      img {
        background: transparent;
      }
    }
  }
  .wim-video-container {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    video {
      width: 100%;
      position: absolute;
      top:0;
      left:0;
    }
  }
}

@media(max-width:768px) {
  .wim-image-container {
    .wim-image {
      padding: 0 10px;
    }
  }
}
</style>